module.exports = __webpack_public_path__ + "img/products-equipamiento.4429c955.jpeg";